import { translationNavigation_da } from "./translationNavigation.da";
import { defineDashboardTranslations } from "./translationTypes";
import { translationNavigation_en } from "./translationNavigation.en";
import { translationNavigation_sv } from "./translationNavigation.sv";

export const translationNavigation = defineDashboardTranslations({
  da: translationNavigation_da,
  en: translationNavigation_en,
  sv: translationNavigation_sv,
});
